import React from "react";
import "./Body.css";
import laptop from "./laptop.jpg";
import webs from "./webs.jpg";
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import { Button, Card, CardActionArea, CardActions } from "@material-ui/core";
import Details from "./Details";
import html from "./html-5.svg";
import css from "./css.svg";
import react1 from "./react.svg";
import postG from "./postG.png"
import mysql from "./mysql.png"
import mu from "./mu.svg"
import atom from "./atom.svg"
import django from "./django.png"
import python from "./python.svg"
import node from "./node.svg"
import vs from "./vs.svg"
import gt from "./gt.svg"
import webs5 from "./web5.JPG"
import tweetme from "./tweetme.JPG"
import beer1 from "./beer1.png"
import airbnb from "./airbnb-cl.png"
import netflix from "./netf-clone.png"
import ig from "./ig=clone.png"
function Body() {
	return (
		<div className="mainBody">
			<div className="mainBodyabout">
				<div className="mainBodyabout_left">
					<h1>
						HELLO <br></br> IAM <br></br> JOSHUA NDELEVA.M{" "}
					</h1>
					<span className="mainBodyabout_leftTitle">About me</span>
					<p>
						I am experienced in web development using react js for
						frontend development and django in backend, SQL,
						Postgress databases.I have experience in model View
						Controller (MVC)
					</p>
					<Button className="mainBody_contact">Contact me</Button>
					<Button className="mainBody_hire">Hire me</Button>
				</div>
				<div className="mainBodyabout_right">
					<img src={webs} alt="" />
				</div>
			</div>
			<h1 className="mainBodySkills_title">Education</h1>
			<div className="mainBodySkills">
				<div className="mainBodySkills_left">
					<img src={laptop} alt="" />
				</div>
				<div className="mainBodySkills_right">
					<Details
						title="Software development"
						institution="Emoblis Software developmentAcademy"
						description="I completed my software development course at Emobilis mobile technology institute 2019
                        whereby i were equiped with full skills in webdevelopment and mobile softwares.
                        I am so glad to have been able so complete my course which i was so passionate about it,
                        i learned coding in order to solve problems in my society thereby making life easy for us and future
                    "
					/>
					<Details
						title="Bsc Industrial Mathematics"
						institution="Jomo Kenyatta University of Agriculture and Technology"
						description="Student"
					/>
				</div>
			</div>
			<div className="mainBodySkills_mainSkills">
				<h1>
					What i can Do <br></br>
					<span className="subheading">Skills</span>
				</h1>
			</div>
			<div className="language_skills">
				<div className="webdevelopment">
					<div className="category_title">
						<h1>Front-end</h1>
						<div className="front-end-tools">
							<img src={html} alt="" />
							<img src={react1} alt="" />
							<img src={css} alt="" />
						</div>
					</div>
					<div className="category_title">
						<h1>Backend</h1>
						<div className="backend_Tools">
							<img src={django} alt="" />
							<img src={node} alt="" />
							<img src={python} alt="" />
						</div>
					</div>
				</div>
				<div className="tools-databases">
					<div className="category_title">
						<h1>Databases</h1>
						<div className="databases">
							<img src={postG} alt="" />
							<img src={mysql} alt="" />
							
						</div>
					</div>
					<div className="category_title">
						<h1>Project-tools/ IDES</h1>
						<div className="databases">
							<img src={gt} alt="" />
							<img src={atom} alt="" />
							<img src={vs} alt="" />
							<img src={css} alt="" />
						</div>
					</div>
				</div>
			</div>
			<div className="myprojects">
				<h1>Projects</h1>
				<div className="projectScreenshots">
					<Card>
						<CardActionArea>
							<CardMedia
								component="img"
								height=""
								image={webs5}
							/>
							<CardContent>
								<p>An in-house web application built for tracking customers’ enquiries on real-estate property to either buy or sell utilizing Angular, TypeScript, HTML, SASS and Firebase.</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires"><a href="https://github.com/joshuandeleva">Checkout</a></Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card>
						<CardActionArea>
							<CardMedia
								component="img"
								height=""
								image={tweetme}
							/>
							<CardContent>
								<p>An in-house web application built for tracking customers’ enquiries on real-estate property to either buy or sell utilizing Angular, TypeScript, HTML, SASS and Firebase.</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires"><a href="https://tweetme-40228.web.app">Checkout</a></Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card>
						<CardActionArea>
							<CardMedia
								component="img"
								height=""
								image={ig}
							/>
							<CardContent>
								<p>creating account with firebase , uploading anf retrieving the data</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires"><a href="https://instagram-clone-e7098.web.app">Checkout</a></Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card className="cardProjects">
						<CardActionArea>
							<CardMedia
								component="img"
								height="250px"
								image={netflix}
							/>
							<CardContent>
								<p>A real time movies site which utilizes the tmdb .org api to get the movies and categorizes into according to genre and trends</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires"><a href="https://netflix-clone-7dfee.web.app">Checkout</a></Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card className="cardProjects">
						<CardActionArea>
							<CardMedia
								component="img"
								height="250px"
								image={airbnb}
							/>
							<CardContent>
								<p>airbnb challenge</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires"><a href="https://airbnb-clone-71d27.web.app">Checkout</a></Button>
							</CardActions>
						</CardActionArea>
					</Card>
					<Card className="cardProjects">
						<CardActionArea>
							<CardMedia
								component="img"
								height="250px"
								image={beer1}
							/>
							<CardContent>
								<p>Aapplications generating random beers using the punky beer api ,shares out the different levels of alcohol and year of make.</p>
							</CardContent>
							<CardActions>
								<Button className="mainBody_hires"><a href="https://punkbeer-api.netlify.app">Checkout</a></Button>
							</CardActions>
						</CardActionArea>
					</Card>
				</div>
			</div>
		</div>
	);
}
export default Body;
